import { BUYER_FEE_TIERS, BUYER_FEE_NOTES, BUYER_FEE_FIXED_EXPLANATION } from "../data/content";

// Buyer Advocacy total-fee table. Single shared data source (content.js) so
// the service page, Fees page, FAQ and concierge cannot diverge.
export const FeeTierTable = ({ dark = false }) => (
  <div data-testid="buyer-fee-tiers">
    <table className="w-full text-sm">
      <caption className="sr-only">
        Buyer Advocacy total professional fee including GST, by agreed purchase budget
      </caption>
      <thead>
        <tr className={dark ? "text-ivory/50" : "text-charcoal/50"}>
          <th scope="col" className="py-2 pr-4 text-left text-[11px] font-semibold tracking-[0.16em] uppercase">
            Agreed purchase budget
          </th>
          <th scope="col" className="py-2 text-right text-[11px] font-semibold tracking-[0.16em] uppercase">
            Total fee incl. GST
          </th>
        </tr>
      </thead>
      <tbody>
        {BUYER_FEE_TIERS.map((t) => (
          <tr key={t.budget} className={dark ? "border-t border-white/15" : "border-t border-charcoal/15"}>
            <td className={`py-2.5 pr-4 ${dark ? "text-ivory/80" : "text-charcoal/75"}`}>{t.budget}</td>
            <td className={`py-2.5 text-right font-serif text-lg font-medium ${dark ? "text-goldlight" : "text-charcoal"}`}>
              {t.fee}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
    <ul className={`mt-4 space-y-1.5 text-xs leading-relaxed ${dark ? "text-ivory/55" : "text-charcoal/60"}`}>
      {BUYER_FEE_NOTES.map((n) => (
        <li key={n}>{n}</li>
      ))}
    </ul>
    <p className={`mt-4 text-xs leading-relaxed ${dark ? "text-ivory/70" : "text-charcoal/70"}`} data-testid="buyer-fee-fixed-note">
      {BUYER_FEE_FIXED_EXPLANATION}
    </p>
  </div>
);
